import { render, staticRenderFns } from "./index--detail.vue?vue&type=template&id=0e9f8aa6&scoped=true&"
import script from "./index--detail.vue?vue&type=script&lang=js&"
export * from "./index--detail.vue?vue&type=script&lang=js&"
import style0 from "./index--detail.vue?vue&type=style&index=0&id=0e9f8aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9f8aa6",
  null
  
)

export default component.exports